import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { NodeGroup, EASING } from '@fiverr-private/transition';
import { BriefSection } from '../../../types';
import { disabledBriefEditorOpacity } from '../../../common/constants';
import { BriefTitle } from './BriefTitle';
import { Section } from './BriefSection';

const STARTING_DELAY = 300;

export const IncludedSections = ({
  sections,
  editedSectionId,
}: {
  sections: BriefSection[];
  editedSectionId: string | null;
}) => {
  const isEditing = !!editedSectionId;

  return sections.length ? (
    <NodeGroup
      data={sections}
      keyAccessor={(d) => d.id}
      start={() => ({ opacity: [0] })}
      enter={(_, index) => ({
        opacity: [1],
        timing: {
          duration: 300,
          delay: index * 50 + STARTING_DELAY,
          ease: EASING.easeIn,
        },
      })}
    >
      {(nodes) => (
        <Stack
          paddingY="6"
          paddingX="5"
          direction="column"
          gap="0"
          overflowY="auto"
          overflowX="hidden"
          width="100%"
          flex="1 1 auto"
        >
          <BriefTitle />
          <Stack direction="column" gap="3">
            {nodes.map(({ key, state: { opacity }, data }) => {
              const section = data as BriefSection;
              const editingOpacity = editedSectionId === section.id ? 1 : disabledBriefEditorOpacity;
              const opacityValue = isEditing ? editingOpacity : opacity;

              return <Section key={key} opacity={opacityValue} section={section} />;
            })}
          </Stack>
        </Stack>
      )}
    </NodeGroup>
  ) : null;
};
